export function getRegisterFunction(definition: CustomElementConstructor) {
  return function (name: string) {
    const previousDefinition = customElements.get(name);
    if (previousDefinition) return;
    customElements.define(name, class extends definition {});
  };
}